export default __webpack_public_path__ + "static/media/Cushion@1x.0bce560c.png";